import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';
import mockData from '../mocks/mapData.json';

const DEFAULT_USE_MOCK = process.env.REACT_APP_USE_MOCK_MAP === 'true';

/**
 * 全国ラリー一覧取得フック
 *
 * - useMock=true (or REACT_APP_USE_MOCK_MAP=true): src/mocks/mapData.json を返す（開発用）
 * - それ以外: Firestoreの /mapRallies コレクションを全件取得する
 *
 * @param {{ useMock?: boolean }} options
 * @returns {{ rallies: Array, loading: boolean, error: Error | null }}
 */
const useMapRallies = ({ useMock = DEFAULT_USE_MOCK } = {}) => {
  const [rallies, setRallies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    // ── モックモード ──────────────────────────────────────────
    if (useMock) {
      const data = mockData.rallies.filter((r) => r.isActive !== false);
      setRallies(data);
      setLoading(false);
      return;
    }

    // ── 本番モード（Firestore） ───────────────────────────────
    let cancelled = false;

    const fetchRallies = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'mapRallies'));
        if (cancelled) return;
        const data = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((r) => r.isActive !== false);
        setRallies(data);
      } catch (e) {
        if (!cancelled) setError(e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchRallies();
    return () => {
      cancelled = true;
    };
  }, [useMock]);

  return { rallies, loading, error };
};

export default useMapRallies;
